export default function validate(values) {
  let errors = {}

  if (!values.alert) {
    errors.alert = 'Please select a valid alert'
  }

  return errors
}
